import { __extends } from "tslib";
import { PinpointClient } from "./PinpointClient";
import { CreateAppCommand } from "./commands/CreateAppCommand";
import { CreateCampaignCommand, } from "./commands/CreateCampaignCommand";
import { CreateEmailTemplateCommand, } from "./commands/CreateEmailTemplateCommand";
import { CreateExportJobCommand, } from "./commands/CreateExportJobCommand";
import { CreateImportJobCommand, } from "./commands/CreateImportJobCommand";
import { CreateJourneyCommand, } from "./commands/CreateJourneyCommand";
import { CreatePushTemplateCommand, } from "./commands/CreatePushTemplateCommand";
import { CreateRecommenderConfigurationCommand, } from "./commands/CreateRecommenderConfigurationCommand";
import { CreateSegmentCommand, } from "./commands/CreateSegmentCommand";
import { CreateSmsTemplateCommand, } from "./commands/CreateSmsTemplateCommand";
import { CreateVoiceTemplateCommand, } from "./commands/CreateVoiceTemplateCommand";
import { DeleteAdmChannelCommand, } from "./commands/DeleteAdmChannelCommand";
import { DeleteApnsChannelCommand, } from "./commands/DeleteApnsChannelCommand";
import { DeleteApnsSandboxChannelCommand, } from "./commands/DeleteApnsSandboxChannelCommand";
import { DeleteApnsVoipChannelCommand, } from "./commands/DeleteApnsVoipChannelCommand";
import { DeleteApnsVoipSandboxChannelCommand, } from "./commands/DeleteApnsVoipSandboxChannelCommand";
import { DeleteAppCommand } from "./commands/DeleteAppCommand";
import { DeleteBaiduChannelCommand, } from "./commands/DeleteBaiduChannelCommand";
import { DeleteCampaignCommand, } from "./commands/DeleteCampaignCommand";
import { DeleteEmailChannelCommand, } from "./commands/DeleteEmailChannelCommand";
import { DeleteEmailTemplateCommand, } from "./commands/DeleteEmailTemplateCommand";
import { DeleteEndpointCommand, } from "./commands/DeleteEndpointCommand";
import { DeleteEventStreamCommand, } from "./commands/DeleteEventStreamCommand";
import { DeleteGcmChannelCommand, } from "./commands/DeleteGcmChannelCommand";
import { DeleteJourneyCommand, } from "./commands/DeleteJourneyCommand";
import { DeletePushTemplateCommand, } from "./commands/DeletePushTemplateCommand";
import { DeleteRecommenderConfigurationCommand, } from "./commands/DeleteRecommenderConfigurationCommand";
import { DeleteSegmentCommand, } from "./commands/DeleteSegmentCommand";
import { DeleteSmsChannelCommand, } from "./commands/DeleteSmsChannelCommand";
import { DeleteSmsTemplateCommand, } from "./commands/DeleteSmsTemplateCommand";
import { DeleteUserEndpointsCommand, } from "./commands/DeleteUserEndpointsCommand";
import { DeleteVoiceChannelCommand, } from "./commands/DeleteVoiceChannelCommand";
import { DeleteVoiceTemplateCommand, } from "./commands/DeleteVoiceTemplateCommand";
import { GetAdmChannelCommand, } from "./commands/GetAdmChannelCommand";
import { GetApnsChannelCommand, } from "./commands/GetApnsChannelCommand";
import { GetApnsSandboxChannelCommand, } from "./commands/GetApnsSandboxChannelCommand";
import { GetApnsVoipChannelCommand, } from "./commands/GetApnsVoipChannelCommand";
import { GetApnsVoipSandboxChannelCommand, } from "./commands/GetApnsVoipSandboxChannelCommand";
import { GetAppCommand } from "./commands/GetAppCommand";
import { GetApplicationDateRangeKpiCommand, } from "./commands/GetApplicationDateRangeKpiCommand";
import { GetApplicationSettingsCommand, } from "./commands/GetApplicationSettingsCommand";
import { GetAppsCommand } from "./commands/GetAppsCommand";
import { GetBaiduChannelCommand, } from "./commands/GetBaiduChannelCommand";
import { GetCampaignActivitiesCommand, } from "./commands/GetCampaignActivitiesCommand";
import { GetCampaignCommand } from "./commands/GetCampaignCommand";
import { GetCampaignDateRangeKpiCommand, } from "./commands/GetCampaignDateRangeKpiCommand";
import { GetCampaignVersionCommand, } from "./commands/GetCampaignVersionCommand";
import { GetCampaignVersionsCommand, } from "./commands/GetCampaignVersionsCommand";
import { GetCampaignsCommand, } from "./commands/GetCampaignsCommand";
import { GetChannelsCommand } from "./commands/GetChannelsCommand";
import { GetEmailChannelCommand, } from "./commands/GetEmailChannelCommand";
import { GetEmailTemplateCommand, } from "./commands/GetEmailTemplateCommand";
import { GetEndpointCommand } from "./commands/GetEndpointCommand";
import { GetEventStreamCommand, } from "./commands/GetEventStreamCommand";
import { GetExportJobCommand, } from "./commands/GetExportJobCommand";
import { GetExportJobsCommand, } from "./commands/GetExportJobsCommand";
import { GetGcmChannelCommand, } from "./commands/GetGcmChannelCommand";
import { GetImportJobCommand, } from "./commands/GetImportJobCommand";
import { GetImportJobsCommand, } from "./commands/GetImportJobsCommand";
import { GetJourneyCommand } from "./commands/GetJourneyCommand";
import { GetJourneyDateRangeKpiCommand, } from "./commands/GetJourneyDateRangeKpiCommand";
import { GetJourneyExecutionActivityMetricsCommand, } from "./commands/GetJourneyExecutionActivityMetricsCommand";
import { GetJourneyExecutionMetricsCommand, } from "./commands/GetJourneyExecutionMetricsCommand";
import { GetPushTemplateCommand, } from "./commands/GetPushTemplateCommand";
import { GetRecommenderConfigurationCommand, } from "./commands/GetRecommenderConfigurationCommand";
import { GetRecommenderConfigurationsCommand, } from "./commands/GetRecommenderConfigurationsCommand";
import { GetSegmentCommand } from "./commands/GetSegmentCommand";
import { GetSegmentExportJobsCommand, } from "./commands/GetSegmentExportJobsCommand";
import { GetSegmentImportJobsCommand, } from "./commands/GetSegmentImportJobsCommand";
import { GetSegmentVersionCommand, } from "./commands/GetSegmentVersionCommand";
import { GetSegmentVersionsCommand, } from "./commands/GetSegmentVersionsCommand";
import { GetSegmentsCommand } from "./commands/GetSegmentsCommand";
import { GetSmsChannelCommand, } from "./commands/GetSmsChannelCommand";
import { GetSmsTemplateCommand, } from "./commands/GetSmsTemplateCommand";
import { GetUserEndpointsCommand, } from "./commands/GetUserEndpointsCommand";
import { GetVoiceChannelCommand, } from "./commands/GetVoiceChannelCommand";
import { GetVoiceTemplateCommand, } from "./commands/GetVoiceTemplateCommand";
import { ListJourneysCommand, } from "./commands/ListJourneysCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTemplateVersionsCommand, } from "./commands/ListTemplateVersionsCommand";
import { ListTemplatesCommand, } from "./commands/ListTemplatesCommand";
import { PhoneNumberValidateCommand, } from "./commands/PhoneNumberValidateCommand";
import { PutEventStreamCommand, } from "./commands/PutEventStreamCommand";
import { PutEventsCommand } from "./commands/PutEventsCommand";
import { RemoveAttributesCommand, } from "./commands/RemoveAttributesCommand";
import { SendMessagesCommand, } from "./commands/SendMessagesCommand";
import { SendUsersMessagesCommand, } from "./commands/SendUsersMessagesCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateAdmChannelCommand, } from "./commands/UpdateAdmChannelCommand";
import { UpdateApnsChannelCommand, } from "./commands/UpdateApnsChannelCommand";
import { UpdateApnsSandboxChannelCommand, } from "./commands/UpdateApnsSandboxChannelCommand";
import { UpdateApnsVoipChannelCommand, } from "./commands/UpdateApnsVoipChannelCommand";
import { UpdateApnsVoipSandboxChannelCommand, } from "./commands/UpdateApnsVoipSandboxChannelCommand";
import { UpdateApplicationSettingsCommand, } from "./commands/UpdateApplicationSettingsCommand";
import { UpdateBaiduChannelCommand, } from "./commands/UpdateBaiduChannelCommand";
import { UpdateCampaignCommand, } from "./commands/UpdateCampaignCommand";
import { UpdateEmailChannelCommand, } from "./commands/UpdateEmailChannelCommand";
import { UpdateEmailTemplateCommand, } from "./commands/UpdateEmailTemplateCommand";
import { UpdateEndpointCommand, } from "./commands/UpdateEndpointCommand";
import { UpdateEndpointsBatchCommand, } from "./commands/UpdateEndpointsBatchCommand";
import { UpdateGcmChannelCommand, } from "./commands/UpdateGcmChannelCommand";
import { UpdateJourneyCommand, } from "./commands/UpdateJourneyCommand";
import { UpdateJourneyStateCommand, } from "./commands/UpdateJourneyStateCommand";
import { UpdatePushTemplateCommand, } from "./commands/UpdatePushTemplateCommand";
import { UpdateRecommenderConfigurationCommand, } from "./commands/UpdateRecommenderConfigurationCommand";
import { UpdateSegmentCommand, } from "./commands/UpdateSegmentCommand";
import { UpdateSmsChannelCommand, } from "./commands/UpdateSmsChannelCommand";
import { UpdateSmsTemplateCommand, } from "./commands/UpdateSmsTemplateCommand";
import { UpdateTemplateActiveVersionCommand, } from "./commands/UpdateTemplateActiveVersionCommand";
import { UpdateVoiceChannelCommand, } from "./commands/UpdateVoiceChannelCommand";
import { UpdateVoiceTemplateCommand, } from "./commands/UpdateVoiceTemplateCommand";
/**
 * <p>Doc Engage API - Amazon Pinpoint API</p>
 */
var Pinpoint = /** @class */ (function (_super) {
    __extends(Pinpoint, _super);
    function Pinpoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Pinpoint.prototype.createApp = function (args, optionsOrCb, cb) {
        var command = new CreateAppCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createCampaign = function (args, optionsOrCb, cb) {
        var command = new CreateCampaignCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createEmailTemplate = function (args, optionsOrCb, cb) {
        var command = new CreateEmailTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createExportJob = function (args, optionsOrCb, cb) {
        var command = new CreateExportJobCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createImportJob = function (args, optionsOrCb, cb) {
        var command = new CreateImportJobCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createJourney = function (args, optionsOrCb, cb) {
        var command = new CreateJourneyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createPushTemplate = function (args, optionsOrCb, cb) {
        var command = new CreatePushTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createRecommenderConfiguration = function (args, optionsOrCb, cb) {
        var command = new CreateRecommenderConfigurationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createSegment = function (args, optionsOrCb, cb) {
        var command = new CreateSegmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createSmsTemplate = function (args, optionsOrCb, cb) {
        var command = new CreateSmsTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.createVoiceTemplate = function (args, optionsOrCb, cb) {
        var command = new CreateVoiceTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteAdmChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteAdmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteApnsChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteApnsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteApnsSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteApnsSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteApnsVoipChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteApnsVoipChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteApnsVoipSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteApnsVoipSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteApp = function (args, optionsOrCb, cb) {
        var command = new DeleteAppCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteBaiduChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteBaiduChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteCampaign = function (args, optionsOrCb, cb) {
        var command = new DeleteCampaignCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteEmailChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteEmailChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteEmailTemplate = function (args, optionsOrCb, cb) {
        var command = new DeleteEmailTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteEndpoint = function (args, optionsOrCb, cb) {
        var command = new DeleteEndpointCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteEventStream = function (args, optionsOrCb, cb) {
        var command = new DeleteEventStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteGcmChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteGcmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteJourney = function (args, optionsOrCb, cb) {
        var command = new DeleteJourneyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deletePushTemplate = function (args, optionsOrCb, cb) {
        var command = new DeletePushTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteRecommenderConfiguration = function (args, optionsOrCb, cb) {
        var command = new DeleteRecommenderConfigurationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteSegment = function (args, optionsOrCb, cb) {
        var command = new DeleteSegmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteSmsChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteSmsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteSmsTemplate = function (args, optionsOrCb, cb) {
        var command = new DeleteSmsTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteUserEndpoints = function (args, optionsOrCb, cb) {
        var command = new DeleteUserEndpointsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteVoiceChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteVoiceChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.deleteVoiceTemplate = function (args, optionsOrCb, cb) {
        var command = new DeleteVoiceTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getAdmChannel = function (args, optionsOrCb, cb) {
        var command = new GetAdmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApnsChannel = function (args, optionsOrCb, cb) {
        var command = new GetApnsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApnsSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new GetApnsSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApnsVoipChannel = function (args, optionsOrCb, cb) {
        var command = new GetApnsVoipChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApnsVoipSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new GetApnsVoipSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApp = function (args, optionsOrCb, cb) {
        var command = new GetAppCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApplicationDateRangeKpi = function (args, optionsOrCb, cb) {
        var command = new GetApplicationDateRangeKpiCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApplicationSettings = function (args, optionsOrCb, cb) {
        var command = new GetApplicationSettingsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getApps = function (args, optionsOrCb, cb) {
        var command = new GetAppsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getBaiduChannel = function (args, optionsOrCb, cb) {
        var command = new GetBaiduChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaign = function (args, optionsOrCb, cb) {
        var command = new GetCampaignCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaignActivities = function (args, optionsOrCb, cb) {
        var command = new GetCampaignActivitiesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaignDateRangeKpi = function (args, optionsOrCb, cb) {
        var command = new GetCampaignDateRangeKpiCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaigns = function (args, optionsOrCb, cb) {
        var command = new GetCampaignsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaignVersion = function (args, optionsOrCb, cb) {
        var command = new GetCampaignVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getCampaignVersions = function (args, optionsOrCb, cb) {
        var command = new GetCampaignVersionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getChannels = function (args, optionsOrCb, cb) {
        var command = new GetChannelsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getEmailChannel = function (args, optionsOrCb, cb) {
        var command = new GetEmailChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getEmailTemplate = function (args, optionsOrCb, cb) {
        var command = new GetEmailTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getEndpoint = function (args, optionsOrCb, cb) {
        var command = new GetEndpointCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getEventStream = function (args, optionsOrCb, cb) {
        var command = new GetEventStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getExportJob = function (args, optionsOrCb, cb) {
        var command = new GetExportJobCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getExportJobs = function (args, optionsOrCb, cb) {
        var command = new GetExportJobsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getGcmChannel = function (args, optionsOrCb, cb) {
        var command = new GetGcmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getImportJob = function (args, optionsOrCb, cb) {
        var command = new GetImportJobCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getImportJobs = function (args, optionsOrCb, cb) {
        var command = new GetImportJobsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getJourney = function (args, optionsOrCb, cb) {
        var command = new GetJourneyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getJourneyDateRangeKpi = function (args, optionsOrCb, cb) {
        var command = new GetJourneyDateRangeKpiCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getJourneyExecutionActivityMetrics = function (args, optionsOrCb, cb) {
        var command = new GetJourneyExecutionActivityMetricsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getJourneyExecutionMetrics = function (args, optionsOrCb, cb) {
        var command = new GetJourneyExecutionMetricsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getPushTemplate = function (args, optionsOrCb, cb) {
        var command = new GetPushTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getRecommenderConfiguration = function (args, optionsOrCb, cb) {
        var command = new GetRecommenderConfigurationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getRecommenderConfigurations = function (args, optionsOrCb, cb) {
        var command = new GetRecommenderConfigurationsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegment = function (args, optionsOrCb, cb) {
        var command = new GetSegmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegmentExportJobs = function (args, optionsOrCb, cb) {
        var command = new GetSegmentExportJobsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegmentImportJobs = function (args, optionsOrCb, cb) {
        var command = new GetSegmentImportJobsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegments = function (args, optionsOrCb, cb) {
        var command = new GetSegmentsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegmentVersion = function (args, optionsOrCb, cb) {
        var command = new GetSegmentVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSegmentVersions = function (args, optionsOrCb, cb) {
        var command = new GetSegmentVersionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSmsChannel = function (args, optionsOrCb, cb) {
        var command = new GetSmsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getSmsTemplate = function (args, optionsOrCb, cb) {
        var command = new GetSmsTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getUserEndpoints = function (args, optionsOrCb, cb) {
        var command = new GetUserEndpointsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getVoiceChannel = function (args, optionsOrCb, cb) {
        var command = new GetVoiceChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.getVoiceTemplate = function (args, optionsOrCb, cb) {
        var command = new GetVoiceTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.listJourneys = function (args, optionsOrCb, cb) {
        var command = new ListJourneysCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.listTagsForResource = function (args, optionsOrCb, cb) {
        var command = new ListTagsForResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.listTemplates = function (args, optionsOrCb, cb) {
        var command = new ListTemplatesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.listTemplateVersions = function (args, optionsOrCb, cb) {
        var command = new ListTemplateVersionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.phoneNumberValidate = function (args, optionsOrCb, cb) {
        var command = new PhoneNumberValidateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.putEvents = function (args, optionsOrCb, cb) {
        var command = new PutEventsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.putEventStream = function (args, optionsOrCb, cb) {
        var command = new PutEventStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.removeAttributes = function (args, optionsOrCb, cb) {
        var command = new RemoveAttributesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.sendMessages = function (args, optionsOrCb, cb) {
        var command = new SendMessagesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.sendUsersMessages = function (args, optionsOrCb, cb) {
        var command = new SendUsersMessagesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.tagResource = function (args, optionsOrCb, cb) {
        var command = new TagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.untagResource = function (args, optionsOrCb, cb) {
        var command = new UntagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateAdmChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateAdmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateApnsChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateApnsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateApnsSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateApnsSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateApnsVoipChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateApnsVoipChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateApnsVoipSandboxChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateApnsVoipSandboxChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateApplicationSettings = function (args, optionsOrCb, cb) {
        var command = new UpdateApplicationSettingsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateBaiduChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateBaiduChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateCampaign = function (args, optionsOrCb, cb) {
        var command = new UpdateCampaignCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateEmailChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateEmailChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateEmailTemplate = function (args, optionsOrCb, cb) {
        var command = new UpdateEmailTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateEndpoint = function (args, optionsOrCb, cb) {
        var command = new UpdateEndpointCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateEndpointsBatch = function (args, optionsOrCb, cb) {
        var command = new UpdateEndpointsBatchCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateGcmChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateGcmChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateJourney = function (args, optionsOrCb, cb) {
        var command = new UpdateJourneyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateJourneyState = function (args, optionsOrCb, cb) {
        var command = new UpdateJourneyStateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updatePushTemplate = function (args, optionsOrCb, cb) {
        var command = new UpdatePushTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateRecommenderConfiguration = function (args, optionsOrCb, cb) {
        var command = new UpdateRecommenderConfigurationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateSegment = function (args, optionsOrCb, cb) {
        var command = new UpdateSegmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateSmsChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateSmsChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateSmsTemplate = function (args, optionsOrCb, cb) {
        var command = new UpdateSmsTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateTemplateActiveVersion = function (args, optionsOrCb, cb) {
        var command = new UpdateTemplateActiveVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateVoiceChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateVoiceChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    Pinpoint.prototype.updateVoiceTemplate = function (args, optionsOrCb, cb) {
        var command = new UpdateVoiceTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    return Pinpoint;
}(PinpointClient));
export { Pinpoint };
//# sourceMappingURL=Pinpoint.js.map